import { TextField } from './ContactInfo.types';

export const resolvePrePopulateCheckboxField = (
  isMegaScreenerSite: boolean,
  prePopulateFromScreener?: TextField,
  prePopulateFromMegaScreener?: TextField
) => (isMegaScreenerSite ? prePopulateFromMegaScreener : prePopulateFromScreener);
